import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AboutUsSection = () => {
  const stats = [
  {
    value: "2 départs/mois",
    label: "Régularité garantie"
  },
  {
    value: "50 000+ colis",
    label: "Expédiés avec succès"
  },
  {
    value: "98% clients",
    label: "Satisfaits"
  },
  {
    value: "Depuis 2009",
    label: "À votre service"
  }];


  return (
    <div className="bg-white py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main 2-Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 mb-16">
          {/* Left Column - Text Content (60%) */}
          <div className="lg:col-span-3">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}>
              
              <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
                Qui sommes-nous ?
              </h2>
              
              <div className="space-y-5 text-slate-700 text-base sm:text-lg leading-relaxed">
                <p>
                  Derrière <span className="font-semibold text-green-700">ADT Express</span>, il y a une équipe qui comprend vos besoins parce qu'elle partage votre histoire. Spécialiste du <span className="font-semibold text-slate-900">transport maritime entre la France et la Côte d'Ivoire</span>, nous avons créé ce service pour une raison simple : rendre l'envoi de colis vers Abidjan accessible, fiable et sans prise de tête.
                </p>
                
                <p>
                  Depuis notre création, nous accompagnons la <span className="font-semibold text-green-700">diaspora ivoirienne</span> et les professionnels qui souhaitent expédier leurs affaires en toute sécurité et à prix juste. <span className="font-semibold text-slate-900">Barriques, envois au volume, conteneurs complets</span> : 2 départs par mois depuis Paris, une solution pour chaque besoin.
                </p>
                
                <p>
                  Des milliers de colis expédiés, des familles reconnectées, des professionnels accompagnés — voilà ce qui nous motive au quotidien.
                </p>
              </div>

              {/* CTA Buttons - Left Aligned */}
              <div className="flex flex-col sm:flex-row gap-4 mt-8">
                <Link to="/dedicated-pricing-page">
                  <Button
                    className="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-3 rounded-lg shadow-md transition-all duration-300">

                    <Icon name="Calculator" size={20} className="mr-2" />
                    Calculer mon devis
                  </Button>
                </Link>
                <Link to="/home-tracking">
                  <Button
                    size="lg"
                    variant="outline"
                    className="w-full sm:w-auto border-2 border-green-600 text-green-700 hover:bg-green-50 font-semibold px-8 py-3 rounded-lg transition-all duration-300">
                    
                    <Icon name="Package" size={20} className="mr-2" />
                    Suivre mon envoi
                  </Button>
                </Link>
              </div>
            </motion.div>
          </div>

          {/* Right Column - Maritime Image (40%) */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:col-span-2">
            
            <div className="relative h-full min-h-[400px] rounded-2xl overflow-hidden shadow-xl">
              {/* Maritime Container Image */}
              <img
                src="https://img.rocket.new/generatedImages/rocket_gen_img_18e42d384-1780788252459.png"
                alt="Conteneurs maritimes au port - Transport ADT Express"
                className="w-full h-full object-cover" />
              
              {/* Overlay Badge */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-xl p-4 shadow-lg">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name="Ship" size={24} color="white" />
                  </div>
                  <div>
                    <p className="font-bold text-slate-900 text-sm">Transport Maritime Professionnel</p>
                    <p className="text-xs text-slate-600">Paris → Anvers → Abidjan</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Stats Banner - Green Background */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="bg-green-800 rounded-2xl shadow-2xl overflow-hidden">
          
          <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-green-700">
            {stats?.map((stat, index) =>
            <div
              key={index}
              className="px-6 py-8 text-center hover:bg-green-700/50 transition-colors duration-300">
              
                <div className="text-3xl sm:text-4xl font-bold text-white mb-2">
                  {stat?.value}
                </div>
                <div className="text-sm sm:text-base text-green-100 font-medium">
                  {stat?.label}
                </div>
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </div>);







};

export default AboutUsSection;